<template>
  <v-menu
    ref="menu"
    v-model="isMenuVisible"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="390px"
    :close-on-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="category-picker">
        <div class="category-picker__input" v-bind="attrs" v-on="on">
          <v-icon color="primary" class="category-picker__icon mr-2">
            icon-tags
          </v-icon>

          {{
            selectedItem
              ? selectedItem.name
              : $t("message.reviews.tags.selectTag")
          }}
          <v-icon size="24px" color="primary">
            mdi-chevron-down
          </v-icon>
        </div>
      </div>
    </template>
    <v-card class="category-card" in-height="400px">
      <v-text-field
        v-model="searchValue"
        class="category-card__search-field"
        :label="$t('message.reviews.categories.categorySearchLabel')"
        prepend-inner-icon="icon-search"
        clearable
        outlined
        rounded
        :hide-details="true"
      ></v-text-field>
      <template v-if="localTags.length > 0">
        <v-list class="category-list">
          <v-list-item-group v-model="selectedItemTmp" color="primary">
            <v-list-item
              v-for="item in filteredTags"
              :key="item.id"
              :value="item.id"
            >
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <div class="category-picker__actions">
          <v-btn
            text
            @click="(isMenuVisible = false), (selectedItemTmp = null)"
          >
            {{ $t("message.common.cancel") }}</v-btn
          >
          <v-btn text color="primary" @click="selectedCategoryHandler">{{
            $t("message.common.save")
          }}</v-btn>
        </div>
      </template>
      <div v-else class="category-card__no-data">
        <v-progress-circular
          indeterminate
          color="primary"
          size="25"
          width="3"
        />
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
export default {
  name: "ReviewsCategoriesCategoryPicker",
  props: {
    placeholder: {
      type: Object
    },
    tags: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredTags() {
      if (!this.searchValue) return this.localTags;
      return this.localTags.filter(item => {
        return item.name.toLowerCase().includes(this.searchValue);
      });
    }
  },
  data() {
    return {
      isMenuVisible: false,
      selectedItem: null,
      selectedItemTmp: null,
      searchValue: null,
      localTags: null
    };
  },
  watch: {
    isMenuVisible(current) {
      if (this.tags.length || !current) {
        return;
      }
      this.$emit("get-tags");
    },
    tags: {
      immediate: true,
      handler() {
        this.localTags = this.tags;
      }
    },
    placeholder(current) {
      this.selectedItem = current;
      this.selectedItemTmp = current.id;
    }
  },
  methods: {
    selectedCategoryHandler() {
      if (!this.selectedItemTmp) {
        return;
      }
      this.selectedItem = this.tags.find(item => {
        return item.id == this.selectedItemTmp;
      });

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_DETAILS_CATEGORY_CHANGE,
        category_name: this.selectedItem.name
      });
      this.$emit("category-selected", {
        id: this.selectedItem.id,
        allReviews: this.selectedItem.allReviews,
        withoutCategory: this.selectedItem.withoutCategory
      });
      this.isMenuVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.category-list {
  max-height: 250px;
  overflow-y: auto;
}

.category-picker {
  border-radius: 20px;
  height: 46px;
  padding: 0 $spacing * 2;
  border: 1px solid $primary;
  max-width: 250px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $primary;
  @include font-size(14px);

  &__icon {
    font-weight: 600;
    @include font-size(22px);
  }

  &__input {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }

  &__actions {
    border-top: 1px solid $gray-200;
    padding: $spacing 0;
    display: flex;
    justify-content: flex-end;
    ::v-deep .v-btn {
      text-transform: none;
      letter-spacing: 0;
    }
  }
}
.category-card {
  padding: $spacing * 3 $spacing * 3 0 $spacing * 3;

  ::v-deep .v-list-item__title {
    @include font-size(14px);
  }

  &__no-data {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__search-field {
    margin-bottom: $spacing;

    ::v-deep .v-label {
      @include font-size(14px);
      color: rgba($dark-blue-3, 0.4);
    }
    box-shadow: 0px 0px 30px rgba(54, 60, 86, 0.07);
  }

  display: flex;
  flex-direction: column;
}
</style>
